// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-448b72517e1388d0.js";
if (chunkId === "691") return "js/vendor-super-form-552aa43cbda113ad.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "982cf5283f68d7ac",}[chunkId] + ".chunk.js"
}